export default "__VITE_ASSET__b9Nvzmh6__"